module.exports = __webpack_public_path__ + "img/php-logo.1b29a538.png";